import useModelStoreModule from '@/views/models/common/useModelStoreModule'
import alertsModel from '@/views/models/alerts/alertsModel'

const {
  fetchAll,
} = useModelStoreModule(alertsModel)

export default {
  namespaced: true,
  state: {
    alerts: null,
  },
  getters: {},
  mutations: {
  },
  actions: {
    fetchAll,
  },
}
